<template>
    <div>
        <div class="live-tips-card ive-tips-card--nolive" v-if="liveStatus === 0">
            <div class="content">
                <div class="name">
                    <span class="state">即将直播</span>
                    <span>{{ liveInfor.name }}</span>
                </div>
                <p class="text">{{ liveTimeFormat(liveInfor.start_time, liveInfor.end_time) }}</p>
            </div>

        </div>
        <div class="live-tips-card" v-if="liveStatus === 1">
            <div class="content">
                <div class="name">
                    <img src="@/assets/images/goods/catalog_icon_liveing.gif" class="icon">
                    <span class="state">直播中</span>
                    <span>{{ liveInfor.name }}</span>
                </div>
                <p class="text">{{ liveTimeFormat(liveInfor.start_time, liveInfor.end_time) }}</p>
            </div>
            <div class="footer">
                <div class="button" @click="onButton"><img src="@/assets/images/goods/live_try_play.png"
                        class="icon" />观看
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { formatDate } from '@/utils/date'
export default {
    props: {
        liveInfor: {
            type: Object,
            default: {},
        },
        liveStatus: Number,//0 未开始 1直播中
    },
    computed: {
        liveTimeFormat() {
            return (start_time, end_time) => {
                let start = formatDate(start_time),
                    end = formatDate(end_time)
                return start.md + '  ' + start.hm + '-' + end.hm
            }
        },
    },
    methods: {
        onButton() {
            this.$emit('onButton', this.liveInfor)
        }
    },
    data() {
        return {}
    },
}
</script>

<style lang="scss" scoped>
.live-tips-card {
    display: flex;
    height: 1.57rem;
    background: linear-gradient(180deg, #FFF8F7 0%, #FFFAFA 100%);
    border-radius: 0.21rem;
    padding: .25rem .45rem;
    box-sizing: border-box;
    margin-top: .4rem;

    .content {
        width: 6rem;

        .name {
            @include ellipsis(1);
            font-size: 0.32rem;
            font-weight: 500;
            color: #3C3D42;
            margin-bottom: .1rem;

            .state {
                font-size: 0.29rem;
                font-weight: 500;
                color: #FF6A4D;
                display: inline-block;
                margin-right: .11rem;
            }

            .icon {
                display: inline-block;
                width: 0.43rem;
                transform: translateY(.1rem);
            }
        }
    }

    .footer {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: right;

        .button {
            @include flex_center;
            width: 1.68rem;
            height: 0.64rem;
            background: #FF6A4D;
            border-radius: 0.32rem;
            font-size: 0.29rem;
            font-weight: 400;
            color: #FFFFFF;

            .icon {
                width: 0.16rem;
                margin-right: .08rem;
            }
        }
    }

    .text {
        font-size: 0.27rem;
        font-weight: 400;
        color: #C2C5CC;
    }
}

.ive-tips-card--nolive {
    background: linear-gradient(180deg, #FFF7EA 0%, #FFFAF2 100%);

    .content {
        width: 100%;

        .name .state {
            color: #E5B66E;
        }
    }
}
</style>
